import { Routes } from '@angular/router';
import { LayoutComponent } from '../layout/layout.component';
import { authGuard } from '../guards/auth.guard';
import { AuthenticationComponent } from 'src/app/modules/authentication/authentication.component';
import { UsersComponent } from 'src/app/modules/users/users.component';
import { permissionGuard } from '../guards/permission.guard';
import { redirectGuard } from '../guards/redirect.guard';
import { initRedirectGuard } from '../guards/init-redirect.guard';
import { Permission } from 'src/app/modules/roles/constants/roles.constants';
import { ProfileComponent } from 'src/app/modules/profile/profile.component';
import { LogInsComponent } from 'src/app/modules/log-ins/log-ins.component';
import { TemplatesComponent } from 'src/app/modules/templates/templates.component';
import { GroupsComponent } from 'src/app/modules/groups/groups.component';
import { OrdersComponent } from 'src/app/modules/orders/orders.component';
import { offlineGuard } from '../guards/offline.guard';
import { MachinesComponent } from 'src/app/modules/machines/machines.component';
import { IssuesComponent } from 'src/app/modules/issues/issues.component';
import { SparesComponent } from 'src/app/modules/spares/spares.component';
import { AssignmentsComponent } from 'src/app/modules/assignments/assignments.component';
import { SparesRequestsComponent } from 'src/app/modules/spares-requests/spares-requests.component';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    canActivate: [initRedirectGuard],
    children: [],
  },
  {
    path: 'authentication',
    component: AuthenticationComponent,
    loadChildren: () => import('./authentication.routes').then((m) => m.routes),
  },
  {
    path: 'dashboard',
    component: LayoutComponent,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        canActivate: [redirectGuard],
        children: [],
      },
      {
        path: 'profile',
        component: ProfileComponent,
        canActivate: [offlineGuard, permissionGuard(Permission.ReadMyself)],
        loadChildren: () => import('./profile.routes').then((m) => m.routes),
      },
      {
        path: 'users',
        component: UsersComponent,
        canActivate: [offlineGuard, permissionGuard(Permission.ReadUsers)],
        loadChildren: () => import('./users.routes').then((m) => m.routes),
      },
      {
        path: 'groups',
        component: GroupsComponent,
        canActivate: [offlineGuard, permissionGuard(Permission.ManageGroups)],
        loadChildren: () => import('./groups.routes').then((m) => m.routes),
      },
      {
        path: 'log-ins',
        component: LogInsComponent,
        canActivate: [offlineGuard, permissionGuard(Permission.ReadLogIns)],
        loadChildren: () => import('./log-ins.routes').then((m) => m.routes),
      },
      {
        path: 'templates',
        component: TemplatesComponent,
        canActivate: [offlineGuard, permissionGuard(Permission.ReadTemplates)],
        loadChildren: () => import('./templates.routes').then((m) => m.routes),
      },
      {
        path: 'orders',
        component: OrdersComponent,
        canActivate: [permissionGuard(Permission.ReadOrders)],
        loadChildren: () => import('./orders.routes').then((m) => m.routes),
      },
      {
        path: 'machines',
        component: MachinesComponent,
        canActivate: [offlineGuard, permissionGuard(Permission.ManageMachines)],
        loadChildren: () => import('./machines.routes').then((m) => m.routes),
      },
      {
        path: 'issues',
        component: IssuesComponent,
        canActivate: [permissionGuard(Permission.ReadIssues)],
        loadChildren: () => import('./issues.routes').then((m) => m.routes),
      },
      {
        path: 'spares',
        component: SparesComponent,
        canActivate: [offlineGuard, permissionGuard(Permission.ManageSpares)],
        loadChildren: () => import('./spares.routes').then((m) => m.routes),
      },
      {
        path: 'spares-requests',
        component: SparesRequestsComponent,
        canActivate: [offlineGuard, permissionGuard(Permission.ReadSparesRequests)],
        loadChildren: () => import('./spares-requests.routes').then((m) => m.routes),
      },
      {
        path: 'assignments',
        component: AssignmentsComponent,
        canActivate: [offlineGuard, permissionGuard(Permission.ReadAssignments)],
        loadChildren: () => import('./assignments.routes').then((m) => m.routes),
      },
    ],
  },
  {
    path: '**',
    loadComponent: () =>
      import('./../../shared/components/page-not-found/page-not-found.component').then(
        (c) => c.PageNotFoundComponent
      ),
  },
];
